import { blockedWpExactPaths, blockedWpPathPrefixes } from '../crawler/blocked-wp-paths';
import { buildUniqueSelector } from './selector-utils';

export class EmptyOrUntitledLinksRule {
	constructor(i18n) {
		this.__ = i18n;
		this.key = 'linkTitle';
		this.blockedWpPathPrefixes = blockedWpPathPrefixes;
		this.blockedWpExactPaths = blockedWpExactPaths;
	}

	getDefaultStatus() {
		return 'not_checked';
	}

	evaluate(documentNode, pageUrl = '') {
		const linkNodes = Array.from(documentNode.querySelectorAll('a[href]')).filter((linkNode) => {
			const href = linkNode.getAttribute('href');

			if (!href) {
				return false;
			}

			return !this.isBlockedWpUrl(href, pageUrl);
		});
		const links = linkNodes.map((linkNode) => ({
			href: linkNode.getAttribute('href') || '',
			text: (linkNode.textContent || '').trim(),
			selector: buildUniqueSelector(linkNode)
		}));
		const invalidLinks = links.filter((linkItem) => {
			const textValue = linkItem.text;

			return textValue === '';
		});

		if (linkNodes.length === 0) {
			return {
				status: 'pass',
				message: this.__( 'No links found.', 'a11yfix' ),
				details: {
					links,
					invalidLinks
				}
			};
		}

		if (invalidLinks.length > 0) {
			return {
				status: 'fail',
				message: `${this.__( 'Links without text found:', 'a11yfix' )} ${invalidLinks.length}`,
				details: {
					links,
					invalidLinks
				}
			};
		}

		return {
			status: 'pass',
			message: this.__( 'All links have text.', 'a11yfix' ),
			details: {
				links,
				invalidLinks
			}
		};
	}

	isBlockedWpUrl(rawUrl, pageUrl = '') {
		try {
			const parsedUrl = new URL(rawUrl, pageUrl || window.location.origin);
			const pathname = parsedUrl.pathname;

			if (this.blockedWpPathPrefixes.some((blockedPrefix) => pathname.includes(blockedPrefix))) {
				return true;
			}

			if (this.blockedWpExactPaths.some((blockedPath) => pathname.endsWith(blockedPath))) {
				return true;
			}

			return false;
		} catch {
			return false;
		}
	}
}
